import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    let [booking] = data?.filter(item => item.state === 'SCHEDULED') || []
    return booking
  }, [data])
}
